// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_3CNcMdQkcHcFyddHiQKdIG","row":"_14vcIHl86hWX3Me79lvQ10","countryItem":"_3OiX1TFuFkn-8Zwiac6V5z","dataProjectWrapper":"_1QaZgYDpGBq7FRJTWM4yY","noResults":"_2zVC_KnmCpBy8MSx_Mmjpj","spinnerWrapper":"_3guvPv2YjqcKhLbpnCaEFA","spinner":"_1vKIFFpN-6xS6_uxvnjMV5"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CountryPropertiesList/CountryPropertiesList.scss
// module id = 1599
// module chunks = 0